"use client";
import { ChevronsDown, Github, Menu } from "lucide-react";
import React from "react";
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../ui/sheet";
import { Separator } from "../ui/separator";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "../ui/navigation-menu";
import { Button } from "../ui/button";
import Link from "next/link";
import Image from "next/image";
import { ToggleTheme } from "./toogle-theme";
interface RouteProps {
  href: string;
  label: string;
}

const serviceList = [
  {
    title: "AI & ML Solutions",
    slug: "ai-ml-solutions",
  },
  {
    title: "App Development",
    slug: "mobile-development",
  },
  {
    title: "Web Development",
    slug: "full-stack-development",
  },
    {
      title: "UI/UX Design",
      slug: "ui-ux-design",
    },
    {
      title: "Digital Marketing",
      slug: "digital-marketing",
    },
]

const routeList: RouteProps[] = [
  {
    href: "/projects",
    label: "Projects",
  },
  {
    href: "/#testimonials",
    label: "Testimonials",
  },
  {
    href: "/#team",
    label: "Team",
  },
  {
    href: "/contact-us",
    label: "Contact",
  },
  {
    href: "/#faq",
    label: "FAQ",
  },
];
export const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <header className="shadow-inner  bg-opacity-15 w-[90%] md:w-[70%] lg:w-[75%] lg:max-w-screen-xl top-3 mx-auto sticky border border-black z-40 rounded-2xl flex justify-between items-center p-2 bg-card">
      <Link href="/" className="font-bold text-lg flex items-center">
        <Image src={"/PrismX.svg"} alt="PrismX Logo" width={30} height={30} />
        
        PrismX
      </Link>
      {/* <!-- Mobile --> */}
      <div className="flex items-center lg:hidden">
        <Sheet open={isOpen} onOpenChange={setIsOpen}>
          <SheetTrigger asChild>
            <Menu
              onClick={() => setIsOpen(!isOpen)}
              className="cursor-pointer lg:hidden"
            />
          </SheetTrigger>

          <SheetContent
            side="left"
            className="flex flex-col justify-between rounded-tr-2xl rounded-br-2xl bg-card border-secondary"
          >
            <div>
              <SheetHeader className="mb-4 ml-4">
                <SheetTitle className="flex items-center">
                  <Link href="/" className="flex items-center">
                    <Image src={"/PrismX.svg"} alt="PrismX Logo" width={30} height={30} />
                    PrismX
                  </Link>
                </SheetTitle>
              </SheetHeader>

              <div className="flex flex-col gap-2">
                {routeList.map(({ href, label }) => (
                  <Button
                    key={href}
                    onClick={() => setIsOpen(false)}
                    asChild
                    variant="ghost"
                    className="justify-start text-base"
                  >
                    <Link href={href}>{label}</Link>
                  </Button>
                ))}
              </div>
            </div>

            <SheetFooter className="flex-col sm:flex-col justify-start items-start">
              <Separator className="mb-2" />

              <ToggleTheme />
            </SheetFooter>
          </SheetContent>
        </Sheet>
      </div>

      {/* <!-- Desktop --> */}
      <NavigationMenu className="hidden lg:block mx-auto">
        <NavigationMenuList>
          <NavigationMenuItem>
            <NavigationMenuTrigger className="bg-card text-base hover:text-primary font-bold cursor-pointer">
              <Link href="/services">
              Services
              </Link> 
            </NavigationMenuTrigger>
            <NavigationMenuContent >
              <div className="grid w-[300px]  p-4">
                <ul className="flex flex-col gap-2">
                  {serviceList.map((_items: any,_index: number) => (
                    <Link key={`${_items}${_index}`} href={`/services/${_items.slug}`}>
                    <li
                      
                      className="rounded-md p-3 text-sm hover:bg-muted"
                    >
                      {/* <Link href={`/services/${title.toLowerCase().replace(/ /g, '-')}`}> */}
                        <p className="mb-1 font-semibold leading-none text-foreground">
                          {_items.title}
                        </p>
                    </li>
                      </Link>
                  ))}
                </ul>
              </div>
            </NavigationMenuContent>
          </NavigationMenuItem>

          <NavigationMenuItem>
            {routeList.map(({ href, label }) => (
              <NavigationMenuLink key={href} asChild>
                <Link href={href} className="text-base font-bold hover:text-primary px-2">
                  {label}
                </Link>
              </NavigationMenuLink>
            ))}
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>

      <div className="hidden lg:flex">
        <ToggleTheme />

        <Button asChild size="sm" variant="ghost" aria-label="View on GitHub">
          <Link
            aria-label="GitHub"
            href="https://github.com/Team-PrismX"
            target="_blank"
          >
            <Github className="size-5" />
          </Link>
        </Button>
      </div>
    </header>
  );
};
